import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { ReporteVenta } from "../interfaces/erp/reporte-venta/reporte-venta.interface"
import { booleanCell, calcColorCalculatorMaterialUI, cellNotFilter } from "../utils"
import {
  InfoAgendamiento,
  InfoPreagendamiento,
  InfoPreventa,
  InfoProspecto
} from "@/erp/sale/supervisor_venta/reporte-venta-eva/componente"
import InfoUser from "../components/ui/InfoUser/InfoUser"
import { Chip } from "@mui/material"
import InfoOrdenTrabajo from "@/erp/sale/supervisor_venta/reporte-venta-eva/componente/InfoOrdenTrabajo"


export const useTableColumnsReporteGeneralEVA = () => {

  const columnBase = useMemo<MRT_ColumnDef<ReporteVenta>[]>(() => [
    {
      id: 'razon_social',
      accessorKey: 'razon_social',
      header: 'Nombre',
      size: 300,
      disableSortBy: true,
      Cell: ({ row }) => (
        `${row.original?.razon_social} ${row.original.linea != 1 ? `- LINEA ${row.original.linea}` : ''}` || '—'
      ),
    },
    {
      id: 'identificacion',
      accessorKey: 'identificacion',
      header: 'identificacion'
    },

    {
      ...cellNotFilter,
      id: 'user_create',
      accessorKey: 'user_create',
      header: 'Asesor',
      Cell: ({ row }) => {
        return (
          <InfoUser
            user={row.original.user_create}
          />
        )
      }
    },
    {
      ...cellNotFilter,
      id: 'canal_venta_create',
      accessorKey: 'canal_venta_create',
      header: 'Canal Venta'
    },
    {
      ...cellNotFilter,
      id: 'flujo_venta',
      accessorKey: 'flujo_venta',
      header: 'Flujo Venta',
      Cell: ({ row }) => {
        const {
          flujo_venta
        } = row.original

        return <Chip
          variant="outlined"
          color={calcColorCalculatorMaterialUI(flujo_venta) as any}
          label={flujo_venta}
        />
      }
    },
    {
      ...cellNotFilter,
      id: 'estado_venta',
      accessorKey: 'estado_venta',
      header: 'Estado Venta',
      Cell: ({ row }) => {
        const {
          estado_venta
        } = row.original
        return <Chip
          variant="outlined"
          color={calcColorCalculatorMaterialUI(estado_venta) as any}
          label={estado_venta}
        />
      }
    },

    {
      ...cellNotFilter,
      id: 'prospecto',
      accessorKey: 'prospecto',
      header: 'prospecto',
      Cell: ({ row }) => {
        return row.original.prospecto != null
          ? <InfoProspecto codigo={row.original.prospecto} />
          : '—'
      }
    },
    {
      ...cellNotFilter,
      id: 'preventa',
      accessorKey: 'preventa',
      header: 'preventa',
      Cell: ({ row }) => {
        return row.original.preventa != null
          ? <InfoPreventa codigo={row.original.preventa} />
          : '—'
      }
    },
    {
      ...cellNotFilter,
      id: 'preagendamiento',
      accessorKey: 'preagendamiento',
      header: 'preagendamiento',
      Cell: ({ row }) => {
        return row.original.preagendamiento != null
          ? <InfoPreagendamiento codigo={row.original.preagendamiento} />
          : '—'
      }
    },
    {
      ...cellNotFilter,
      id: 'agendamiento',
      accessorKey: 'agendamiento',
      header: 'agendamiento',
      Cell: ({ row }) => {
        return row.original.agendamiento != null
          ? <InfoAgendamiento codigo={row.original.agendamiento} />
          : '—'
      }
    },
    {
      ...cellNotFilter,
      id: 'orden_trabajo',
      accessorKey: 'orden_trabajo',
      header: 'Orden Trabajo',
      Cell: ({ row }) => {
        return row.original.orden_trabajo != null
          ? <InfoOrdenTrabajo codigo={row.original.orden_trabajo} />
          : '—'
      }
    },

    {
      ...cellNotFilter,
      id: 'solicitud_tutor_descuento',
      accessorKey: 'solicitud_tutor_descuento',
      header: 'Aplica Beneficio',
      Cell: ({ row }) => {
        const {
          solicitud_tutor_descuento,
        } = row.original
        return booleanCell(!!solicitud_tutor_descuento)
      }
    },
    {
      ...cellNotFilter,
      id: 'solicitud_desbloqueo',
      accessorKey: 'solicitud_desbloqueo',
      header: 'Linea Nueva',
      Cell: ({ row }) => {
        const {
          solicitud_desbloqueo,
        } = row.original
        return booleanCell(!!solicitud_desbloqueo)
      }
    },
    {
      ...cellNotFilter,
      id: 'solicitud_fallido',
      accessorKey: 'solicitud_fallido',
      header: 'Liberación de Prospecto',
      Cell: ({ row }) => {
        const {
          solicitud_fallido,
        } = row.original
        return booleanCell(!!solicitud_fallido)
      }
    },

    {
      ...cellNotFilter,
      id: 'solicitud_no_cobro_instalacion',
      accessorKey: 'solicitud_no_cobro_instalacion',
      header: 'Liberación Valor de Instalación',
      Cell: ({ row }) => {
        const {
          solicitud_fallido,
        } = row.original
        return booleanCell(!!solicitud_fallido)
      }
    },
    {
      ...cellNotFilter,
      id: 'pre_requiere_contrato_fisico',
      accessorKey: 'pre_requiere_contrato_fisico',
      header: 'Contrato Físico',
      Cell: ({ row }) => {
        const {
          pre_requiere_contrato_fisico,
        } = row.original
        return booleanCell(pre_requiere_contrato_fisico)
      }
    },
    {
      ...cellNotFilter,
      id: 'solicitud_pasar_deuda',
      accessorKey: 'solicitud_pasar_deuda',
      header: 'Pasar Deuda',
      Cell: ({ row }) => {
        const {
          solicitud_pasar_deuda,
        } = row.original
        return booleanCell(!!solicitud_pasar_deuda)
      }
    },

  ], [])

  return {
    columnBase
  }
}
